import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  OutlinedInput,
  TextField,
  Select,
  Alert,
} from "@mui/material";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { useFormik } from "formik";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";
import axios from "axios";



const Addstore = ({ handleClose, open, onGridReady }: any) => {
    const [date, setDate]= useState(new Date(Date.now() - 0 * 24 * 60 * 60 * 1000))
  const onCloseModal = () => {
    handleClose();
  };

  const docSchema = Yup.object().shape({
    store_id: Yup.string()
      .required("Store Id is Required")
      .min(2, "Minimum 2 characters are required")
      .max(50, "Maximum 50 characters are allowed"),
  });

  const formik = useFormik({
    initialValues: {
    player_id: "",
    store_id: "",
    store_location: "",
    address1: "",
    address2: "",
    banner_name: "",
    city:"",
    device:"",
    device_placement_Easels:"",
    device_position_Easels: "",
    experience: "",
    // installation_date: new Date(Date.now() - 0 * 24 * 60 * 60 * 1000),
    installation_date: new Date(Date.now() - 0 * 24 * 60 * 60 * 1000),
    operation_status: "",
    procurement_status: "",
    state: "",
    store_type: "",
    zip_code: ""
    },
    validationSchema: docSchema,
    onSubmit: async (values:any) => {

    values.installation_date= `${(values.installation_date?.getMonth() + 1).toString().padStart(2, '0')}/${values.installation_date?.getDate().toString().padStart(2, '0')}/${values.installation_date?.getFullYear()}`
    console.log("Submit Data Here After ...", values);
    const result= await axios
      .post("https://api.virtualvisions.io/insertStores", values)
      .then((response) => {
        console.log("Response", response)
        if (response.data === "success") {
            handleClose();
            onGridReady();
            alert("Record Added");
            // <Alert severity="success">Successfully Added New Store !!!</Alert>
          
        }
      })
      .catch((error) => {
        console.log("error",error);
        handleClose();
        alert("Failed to Add Store");
        // <Alert severity="error">Failed to Add New Store !!!</Alert>
    })
    },
  });
  return (
    <>
      <Dialog
        maxWidth={"xl"}
        scroll={"paper"}
        open={open}
        onClose={onCloseModal}
      >
        <DialogTitle>Add Store</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Store Id"
                onChange={formik.handleChange}
                name="store_id"
                fullWidth
                value={formik.values.store_id}
                variant="outlined"
                // helperText={formik.touched.store_id && formik.errors.store_id}
                error={formik.touched.store_id && Boolean(formik.errors.store_id)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Player Id"
                onChange={formik.handleChange}
                fullWidth
                name="player_id"
                value={formik.values.player_id}
                variant="outlined"
                // helperText={formik.touched.player_id && formik.errors.player_id}
                error={formik.touched.player_id && Boolean(formik.errors.player_id)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Store Location"
                onChange={formik.handleChange}
                name="store_location"
                fullWidth
                value={formik.values.store_location}
                variant="outlined"
                // helperText={formik.touched.store_location && formik.errors.store_location}
                error={formik.touched.store_location && Boolean(formik.errors.store_location)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Banner Name"
                onChange={formik.handleChange}
                name="banner_name"
                fullWidth
                value={formik.values.banner_name}
                variant="outlined"
                 />
            </Grid>
            <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                onChange={(value:any) => formik.setFieldValue("installation_date", value?.$d)}
                label="Installation Date"
                format="MM/DD/YYYY"
                value={dayjs(formik.values.installation_date)}
                sx={{ width:'100%'}}
                // onChange={formik.handleChange}
              />
                  </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Operation Status"
                onChange={formik.handleChange}
                name="operation_status"
                fullWidth
                value={formik.values.operation_status}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Device"
                onChange={formik.handleChange}
                name="device"
                fullWidth
                value={formik.values.device}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="City"
                onChange={formik.handleChange}
                name="city"
                fullWidth
                value={formik.values.city}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="State"
                onChange={formik.handleChange}
                name="state"
                fullWidth
                value={formik.values.state}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Experience"
                onChange={formik.handleChange}
                name="experience"
                fullWidth
                value={formik.values.experience}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Procurement Status"
                onChange={formik.handleChange}
                name="procurement_status"
                fullWidth
                value={formik.values.procurement_status}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Zip Code"
                onChange={formik.handleChange}
                name="zip_code"
                fullWidth
                value={formik.values.zip_code}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Store Type"
                onChange={formik.handleChange}
                name="store_type"
                fullWidth
                value={formik.values.store_type}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Device Placement Easels"
                onChange={formik.handleChange}
                name="device_placement_Easels"
                fullWidth
                value={formik.values.device_placement_Easels}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Device Position Easels"
                onChange={formik.handleChange}
                name="device_position_Easels"
                fullWidth
                value={formik.values.device_position_Easels}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Address1"
                onChange={formik.handleChange}
                name="address1"
                fullWidth
                value={formik.values.address1}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Address2"
                onChange={formik.handleChange}
                name="address2"
                fullWidth
                value={formik.values.address2}
                variant="outlined"
                // helperText={formik.touched.address && formik.errors.address}
                // error={formik.touched.address && Boolean(formik.errors.address)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseModal}>Close</Button>
          <Button onClick={()=>formik.handleSubmit()}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Addstore;
